import React from 'react'
import { useParams } from 'react-router-dom'
import {Link} from "react-router-dom"


const PostPage = ({posts,handleDelete}) => {

  const {id} = useParams()
  const post = posts.find((el=>(el.id).toString() === id))
  return (
    <main className='PostPage'>
        <article className='post'>
            {post&&
            <>
            <h2>{post.title}</h2>
            <p className='postDate'>{post.datetime}</p>
            <p className='postBody'>{post.body}</p>
            <Link to = {`/edit/${id}`}><button id="editbutton" style={{backgroundColor:"black"}}>edit post</button></Link>
            <button  id="deleteButton" style={{backgroundColor:"red"}} onClick={()=>handleDelete(post.id)}>Delete post</button>
            </>}

            {!post&&
            <>
           <h2>Post not found</h2>
           <p>well,thats disappointed</p>
           <p>
            <Link to="/">vist our website</Link>
           </p>
            </>}
        </article>
    </main>
  )
}

export default PostPage